import { render, staticRenderFns } from "./TwoRow.vue?vue&type=template&id=320dfa4e"
import script from "./TwoRow.vue?vue&type=script&lang=js"
export * from "./TwoRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports